import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { jsPDF } from 'jspdf';
import * as _ from 'lodash';

@Component({
  selector: 'app-scores',
  templateUrl: './scores.component.html',
  styleUrls: ['./scores.component.scss']
})
export class ScoresComponent implements OnInit {

  constructor(private courseService: CourseService) { }
  scores: any = {};
  courseNames: any[] = [];

  ngOnInit(): void {
    this.courseService.getAllScores().subscribe(
      (res: any) => {
        for (let i = 0; i < res.length; i++) {
          if (this.scores[res[i].courseTitle]) {
            this.scores[res[i].courseTitle].push((res[i].correctAnswers / res[i].totalNumberOfQuestions) * 100)
          } else {
            this.scores[res[i].courseTitle] = [];
            this.scores[res[i].courseTitle].push((res[i].correctAnswers / res[i].totalNumberOfQuestions) * 100)
          }
        }
        let courseDetails = _.uniqBy(res, 'courseTitle');
        this.courseNames = _.map(courseDetails, cd => { return {
          name: cd.courseTitle, 
          id: cd.purchasedCourseId, 
          isComplete: cd.isComplete
        }})
      }
    )
  }

  onClickCertificate(course) {
    this.courseService.getCertificate(course.id).subscribe(
      (res: any) => {
        const doc = new jsPDF('l', 'px', [1123, 794]);
        doc.html(res.template, {
          callback: (doc: jsPDF) => {
            doc.deletePage(2);
            doc.save(`${course.name} Certificate`);
          }
        });
      }
    )
  }

  getAverage(marks) {
    let sum = 0;
    for (let i = 0; i < marks.length; i++) {
      sum = sum + marks[i];
    }
    return (sum / marks.length);
  }

}
